import React from 'react';

const SBoxTable = ({ sBoxData, highlightedRow, highlightedColumn }) => {
  const tableStyle = {
    borderCollapse: 'collapse',
    margin: '18px',
    fontSize: '10px', // Adjust the font size
  };

  const cellStyle = {
    border: '1px solid #000',
    padding: '4px',
  };

  const highlightedRowStyle = {
    backgroundColor: 'yellow',
  };

  const highlightedColumnStyle = {
    backgroundColor: 'lightgreen',
  };

  const intersectingCellStyle = {
    backgroundColor: 'lightblue',
  };

  return (
    <table style={tableStyle}>
      <thead>
        <tr>
          <th style={cellStyle}></th>
          {[...Array(16).keys()].map((index) => (
            <th
              key={`col-header-${index}`}
              style={
                parseInt(highlightedColumn, 16) === index ? highlightedColumnStyle : cellStyle
              }
            >
              {index.toString(16).toUpperCase()}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {sBoxData.map((row, rowIndex) => (
          <tr
            key={`row-${rowIndex}`}
            style={parseInt(highlightedRow, 16) === rowIndex ? highlightedRowStyle : null}
          >
            <th style={cellStyle}>{rowIndex.toString(16).toUpperCase()}</th>
            {row.map((cell, columnIndex) => (
              <td
                key={`col-${columnIndex}`}
                style={
                  highlightedRow === rowIndex || highlightedColumn === columnIndex.toString(16)
                    ? { ...intersectingCellStyle, ...cellStyle }
                    : cellStyle
                }
              >
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SBoxTable;
